"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = exports.Geometry = exports.LocationType = exports.AddressComponent = exports.AddressType = exports.JSON_API_URL = void 0;
const effect_1 = require("effect");
const common_1 = require("../common");
const NAMESPACE = 'Google.Geocode';
exports.JSON_API_URL = 'https://maps.googleapis.com/maps/api/geocode/json';
exports.AddressType = effect_1.Schema.Literal('street_address', 'route', 'intersection', 'political', 'country', 'administrative_area_level_1', 'administrative_area_level_2', 'administrative_area_level_3', 'administrative_area_level_4', 'administrative_area_level_5', 'administrative_area_level_6', 'administrative_area_level_7', 'colloquial_area', 'locality', 'sublocality', 'sublocality_level_1', 'sublocality_level_2', 'sublocality_level_3', 'sublocality_level_4', 'sublocality_level_5', 'neighborhood', 'premise', 'subpremise', 'postal_code', 'natural_feature', 'airport', 'park', 'point_of_interest', 'floor', 'establishment', 'parking', 'post_box', 'postal_town', 'room', 'street_number', 'bus_station', 'train_station', 'transit_station', 'plus_code', 'postal_code_suffix', 'postal_code_prefix', 'town_square', 'archipelago', 'museum', 'pharmacy', 'place_of_worship', 'landmark').annotations({
    identifier: `${NAMESPACE}.AddressType`,
});
exports.AddressComponent = effect_1.Schema.Struct({
    long_name: effect_1.Schema.String,
    short_name: effect_1.Schema.String,
    types: effect_1.Schema.Set(exports.AddressType),
}).annotations({
    identifier: `${NAMESPACE}.AddressComponent`,
});
exports.LocationType = effect_1.Schema.Literal('ROOFTOP', 'RANGE_INTERPOLATED', 'GEOMETRIC_CENTER', 'APPROXIMATE').annotations({
    identifier: `${NAMESPACE}.LocationType`,
});
exports.Geometry = effect_1.Schema.Struct({
    location: common_1.LatLng,
    location_type: exports.LocationType,
    viewport: effect_1.Schema.Record({ key: effect_1.Schema.Literal('northeast', 'southwest'), value: common_1.LatLng }),
}).annotations({
    identifier: `${NAMESPACE}.Geometry`,
});
exports.Result = effect_1.Schema.Struct({
    address_components: effect_1.Schema.Array(exports.AddressComponent),
    formatted_address: effect_1.Schema.String,
    geometry: exports.Geometry,
    place_id: effect_1.Schema.String,
    types: effect_1.Schema.Array(exports.AddressType),
}).annotations({
    identifier: `${NAMESPACE}.Result`,
});
//# sourceMappingURL=common.js.map